import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">有猛料想爆料？有线索想提供？欢迎联系编辑团队</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
            <p className="text-sm text-foreground-400 leading-relaxed mb-6">{contactData.description}</p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">爆料邮箱</p>
                  <p className="text-sm text-foreground-200 font-medium">{contactData.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-400">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">微信</p>
                  <p className="text-sm text-foreground-200 font-medium">{contactData.wechat}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-400">
                  <i className="ri-qq-line text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500">QQ</p>
                  <p className="text-sm text-foreground-200 font-medium">{contactData.qq}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
            <h3 className="text-base font-medium text-foreground-200 mb-4">快速留言</h3>
            <div className="space-y-3">
              <input type="text" placeholder="您的昵称" className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-300 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 transition-colors" />
              <input type="email" placeholder="电子邮箱" className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-300 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 transition-colors" />
              <textarea rows={4} placeholder="请输入您的留言内容..." className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-300 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/40 transition-colors resize-none"></textarea>
              <button type="button" className="w-full px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer">提交留言</button>
            </div>
            <p className="text-[11px] text-foreground-600 mt-3 text-center">此为静态展示，请通过上方联系方式直接联系编辑团队</p>
          </div>
        </div>
      </div>
    </section>
  );
}